export const dataTab1 = [
  {
    id: 1,
    title: "QuizMaster AI",
    description:
      "A quiz generating AI app made using GPT-4o, Streamlit, LangChain & Python.",
    imgURL:
      "https://raw.githubusercontent.com/Mubassim-Khan/QuizMaster-AI/refs/heads/master/data/Preview.png",
    webURL: "https://quizmaster-ai.streamlit.app/",
    githubURL: "https://github.com/Mubassim-Khan/QuizMaster-AI",
  },
  {
    id: 2,
    title: "CarHub",
    description:
      "CarHub is a Next.js based car rental app, which provides you multiple features for searching prefered car depending upon your choice.",
    imgURL:
      "https://raw.githubusercontent.com/Mubassim-Khan/CarHub/master/public/Preview.png",
    webURL: "https://car-hub-gray-seven.vercel.app/",
    githubURL: "https://github.com/Mubassim-Khan/CarHub",
  },
  {
    id: 3,
    title: "Spotify Clone",
    description:
      "Spotify Clone is made using Next.js, Typescript, Tailwind CSS & Supabase which allows user to play different songs and much more.",
    imgURL:
      "https://raw.githubusercontent.com/Mubassim-Khan/Spotify-Clone-Next.js/master/assets/Preview.png",
    webURL: "https://spotify-clone-ivory-sigma.vercel.app",
    githubURL: "https://github.com/Mubassim-Khan/Spotify-Clone-Next.js",
  },
  {
    id: 4,
    title: "Imaginify AI",
    description:
      "A powerful AI SaaS platform made using Next.js, Stripe, Clerk, MongoDB Atlas, Tailwind CSS which allows user to manipulate the images.",
    imgURL:
      "https://raw.githubusercontent.com/Mubassim-Khan/Imaginify-AI/refs/heads/master/public/assets/images/Preview.png",
    webURL: "https://imaginify-ai-eight.vercel.app/",
    githubURL: "https://github.com/Mubassim-Khan/Imaginify-AI",
  },
  {
    id: 5,
    title: "zNotebook",
    description:
      "zNotebook is a cloud notebook website, made using React.js, MySQL, Node.js, Bootstrap etc.",
    imgURL:
      "https://raw.githubusercontent.com/Mubassim-Khan/zNotebook/main/src/assets/images/Preview%203.png",
    webURL: "",
    githubURL: "https://github.com/Mubassim-Khan/zNotebook",
  },
  {
    id: 6,
    title: "Netflix Clone",
    description:
      "A Netflix-inspired Clone, built using Vanilla JavaScript to recreate the visual design and layout of the Netflix.",
    imgURL:
      "https://raw.githubusercontent.com/Mubassim-Khan/Netflix-Clone/main/Preview.jpg",
    webURL: "https://netfflix-clone.netlify.app/",
    githubURL: "https://github.com/Mubassim-Khan/Netflix-Clone",
  },
];

export const dataTab2 = [
  {
    id: 1,
    title: "Travel Journal",
    description:
      "A Travel Journal is a dynamic website, having cards of different of places along with its image, description, link of Google Maps & much more.",
    imgURL:
      "https://raw.githubusercontent.com/Mubassim-Khan/My-Travel-Journal/main/src/Components/Preview_Home.png",
    webURL: "https://m-travel-journal.netlify.app/",
    githubURL: "https://github.com/Mubassim-Khan/My-Travel-Journal",
  },
  {
    id: 2,
    title: "DotCom Communications",
    description:
      "A dynamic website which creates the visual UI/UX design and layout of landing & login page.",
    imgURL:
      "https://raw.githubusercontent.com/Mubassim-Khan/Landing---Login-Page/main/src/Assets/Preview.png",
    webURL: "https://m-dotcom.netlify.app/",
    githubURL: "https://github.com/Mubassim-Khan/Landing---Login-Page",
  },
  // {
  //     id: 3,
  //     title: "MAK News App",
  //     description: "A fast, efficient & updated news app, having multiple options & categories of news. Get updated to the world's news of your favorite choice & type.",
  //     imgURL: "",
  //     webURL: "",
  //     githubURL: "https://github.com/Mubassim-Khan/News-App-ReactJS",
  // },
  // {
  //     id: 4,
  //     title: "Text Tools",
  //     description: "Text Tools is React.js based app, which provides you various features to manipulate your text in the way you want.",
  //     imgURL: "https://raw.githubusercontent.com/Mubassim-Khan/TextTools-React-JS/master/src/Assets/Preview.png",
  //     webURL: "https://mtexttools.netlify.app/",
  //     githubURL: "https://github.com/Mubassim-Khan/TextTools-React-JS",
  // },
  {
    id: 5,
    title: "Meme Generator",
    description:
      "Meme Generator allows user to create a meme by inserting text & generators random meme images.",
    imgURL:
      "https://raw.githubusercontent.com/Mubassim-Khan/Meme-Generator/main/src/Assets/Capture.png",
    webURL: "https://m-meme-generator.netlify.app/",
    githubURL: "https://github.com/Mubassim-Khan/Meme-Generator",
  },
  // {
  //     id: 6,
  //     title: "Ticket Booking Assistant",
  //     description: "An AI which books ticket for to save your time. This is made possible by using dialog flow chatbot.",
  //     imgURL: "https://raw.githubusercontent.com/Mubassim-Khan/Ticket-Booking-Assistant/master/assets/Preview.png",
  //     webURL: "https://ticket-booking-assistant.netlify.app/",
  //     githubURL: "https://github.com/Mubassim-Khan/MLSA-BootCamp-Project-Ticket-Booking-Assistant-",
  // }
];

export const dataTab3 = [];
